import { useEffect } from "react";
import Seo from "@/components/Seo";
import { CheatSheetForm } from "@/components/CheatSheetForm";

export default function CheatSheet() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 sm:py-16 grid lg:grid-cols-[1fr_1.1fr] gap-10 items-center" data-testid="cheat-sheet-page">
      <Seo title="Free Sideline Cheat Sheet" brand="VoluntoldHQ" path="/cheat-sheet" image="https://voluntoldhq.com/products/tmhf_sideline_cheat_sheet.png"
        description="The football words you hear on game day, explained. Free." />
      <img src="/products/tmhf_sideline_cheat_sheet-800.webp" srcSet="/products/tmhf_sideline_cheat_sheet-400.webp 400w, /products/tmhf_sideline_cheat_sheet-800.webp 800w"
        sizes="(min-width: 1024px) 45vw, 100vw" alt="Teach Me How to Football: The Sideline Cheat Sheet cover" className="w-full h-auto border-2 border-[#D3CFC0]" data-testid="cheat-sheet-cover" />
      <div>
        <span className="kicker text-[#DB9130]">Teach Me How to Football</span>
        <h1 className="mt-2 font-head font-semibold uppercase text-4xl sm:text-5xl text-[#111315] leading-[1.02]">The Sideline Cheat Sheet</h1>
        <p className="mt-4 text-lg text-[#3A3A3A]">The football words you hear on game day, explained. Free.</p>
        <div className="mt-8 relative"><CheatSheetForm source="cheat_sheet_page" /></div>
      </div>
    </div>
  );
}
